import React, { Dispatch, ReactElement } from 'react';
import { NotificationPreferencesModel } from '../../models/NotificationPreferencesModel';
import { ReducerAction } from './actions';
import { reducer } from './reducer';

export const notificationsPreferencesInitialState: NotificationPreferencesModel = {
    id: '',
    phoneNumber: '',
    shouldReceiveEmail: false,
    shouldReceiveSms: false,
    userName: '',
    userId: ''
};

const NotificationsContext = React.createContext(notificationsPreferencesInitialState);
const NotificationsDispatchContext = React.createContext<Dispatch<ReducerAction>>(() => ({}));

function useNotificationsState() {
    const context = React.useContext(NotificationsContext);
    if (!context) throw new Error('useNotificationsState must be used in NotificationProvider');
    return context;
}

function useNotificationsDispatch() {
    const context = React.useContext(NotificationsDispatchContext);
    if (!context) throw new Error('useNotificationsDispatch must be used in NotificationProvider');
    return context;
}

export type NotificationProviderProps = {
    children: React.ReactNode | ReactElement | ReactElement[];
};

const NotificationsProvider = ({ children, ...props }: NotificationProviderProps) => {
    const [state, dispatch] = React.useReducer(reducer, notificationsPreferencesInitialState);

    return (
        <NotificationsContext.Provider value={state}>
            <NotificationsDispatchContext.Provider value={dispatch}>
                {children}
            </NotificationsDispatchContext.Provider>
        </NotificationsContext.Provider>
    );
};

export { useNotificationsState, useNotificationsDispatch };

export default NotificationsProvider;
